/**
 * Card 54405 (2026-10-15, X DM31803) — Doctor Now customers do not choose a dosage.
 *
 * A Doctor Now clinician decides the dose after reviewing the medical history, so every
 * customer surface that offered a dosage selector (product page, checkout, both offer-page
 * selects) shows this notice instead. DrCare is unchanged. The decision reads PROVIDER
 * METADATA through `isDoctorNowProduct` — never a slug or a product name.
 *
 * Presentation only: each page still resolves its internal dosage exactly as before (URL
 * `dosage` → stored `selectedDosage` → `isDefault` → first active) and still sends that
 * `dosageId` for pricing and the order, so no price, payload or stored record changes.
 *
 * ROLLBACK: revert card 54405's merge commit.
 */
import { isDoctorNowProduct } from './intakeRouting';

const DOCTOR_NOW_DOSAGE_NOTICE =
  'Your clinician will determine the appropriate dosage after reviewing your medical history. A prescription is not guaranteed.';

/** May the customer pick a dosage for this product? False for Doctor Now, true for everything else. */
const canCustomerSelectDosage = (product) => !isDoctorNowProduct(product);

export { DOCTOR_NOW_DOSAGE_NOTICE, canCustomerSelectDosage };
